import { makeStyles, shorthands } from '@fluentui/react-components';
import { tokens } from '@bingads-webui-fluent-component/tokens';

import { Radius, Spacing } from './types';

export const useRadiusStyles = makeStyles<Radius>({
  small: {
    ...shorthands.borderRadius(tokens.adsui_radiusSmall),
  },
  medium: {
    ...shorthands.borderRadius(tokens.adsui_radiusMedium),
  },
  large: {
    ...shorthands.borderRadius(tokens.adsui_radiusLarge),
  },
  'x-large': {
    ...shorthands.borderRadius(tokens.adsui_radiusXLarge),
  },
});

export const usePaddingBlockStyles = makeStyles<Spacing>({
  'xx-small': {
    ...shorthands.paddingBlock(tokens.adsui_spacingXXS),
  },
  'x-small': {
    ...shorthands.paddingBlock(tokens.adsui_spacingXS),
  },
  small: {
    ...shorthands.paddingBlock(tokens.adsui_spacingS),
  },
  'small-nudge': {
    ...shorthands.paddingBlock(tokens.adsui_spacingSNudge),
  },
  medium: {
    ...shorthands.paddingBlock(tokens.adsui_spacingM),
  },
  'medium-nudge': {
    ...shorthands.paddingBlock(tokens.adsui_spacingMNudge),
  },
  large: {
    ...shorthands.paddingBlock(tokens.adsui_spacingL),
  },
  'x-large': {
    ...shorthands.paddingBlock(tokens.adsui_spacingXL),
  },
  'xx-large': {
    ...shorthands.paddingBlock(tokens.adsui_spacingXXL),
  },
  'xxx-large': {
    ...shorthands.paddingBlock(tokens.adsui_spacingXXXL),
  },
});

export const usePaddingInlineStyles = makeStyles<Spacing>({
  'xx-small': {
    ...shorthands.paddingInline(tokens.adsui_spacingXXS),
  },
  'x-small': {
    ...shorthands.paddingInline(tokens.adsui_spacingXS),
  },
  small: {
    ...shorthands.paddingInline(tokens.adsui_spacingS),
  },
  'small-nudge': {
    ...shorthands.paddingInline(tokens.adsui_spacingSNudge),
  },
  medium: {
    ...shorthands.paddingInline(tokens.adsui_spacingM),
  },
  'medium-nudge': {
    ...shorthands.paddingInline(tokens.adsui_spacingMNudge),
  },
  large: {
    ...shorthands.paddingInline(tokens.adsui_spacingL),
  },
  'x-large': {
    ...shorthands.paddingInline(tokens.adsui_spacingXL),
  },
  'xx-large': {
    ...shorthands.paddingInline(tokens.adsui_spacingXXL),
  },
  'xxx-large': {
    ...shorthands.paddingInline(tokens.adsui_spacingXXXL),
  },
});
